import React from 'react';
import AddApplicationBlock from '../AddApplicationBlock';
import MyApplicationsTabs from '../citizen/MyApplicationsTabs';

export default function AddApplicationTab() {
  return <div>
    <MyApplicationsTabs />
    <AddApplicationBlock />
  </div>;
}